import React, { memo } from 'react';
import { getPdfLabelStyle, pdfStyles } from '../../pdfStyles';
import { Page, Text, View } from '@react-pdf/renderer';
import { ControlsTable, Footer, FooterStartComponent, Header, TitleLink } from '../../comps';
import { isEqual } from 'lodash';
import { ControlsPdfQuery } from 'src/graphql/_generated';
import { ColorSet } from 'src/redux/reducers/theme';

type ControlPdf = ControlsPdfQuery['controls'][number];

interface RmpSummaryProps {
  data: ControlPdf[];
  onDone: (pageNumber: number) => void;
  colors: ColorSet;
  logoSrc?: string;
  secondaryColor?: string | null;
}

export const RmpSummary: React.FC<RmpSummaryProps> = memo(
  ({ onDone, data, colors, logoSrc, secondaryColor }) => {
    const labelStyle = getPdfLabelStyle(secondaryColor);

    return (
      <Page size={'A4'} wrap style={pdfStyles.page}>
        <Header colors={colors} logoSrc={logoSrc} />
        <View
          // @ts-ignore
          render={(data) => {
            onDone(data.pageNumber);
          }}
        />
        <View style={pdfStyles.section}>
          <TitleLink title={'Risk Management Plan'} intLinkId={'rmp'} extLink={`risk-management`} colors={colors} />

          <View style={pdfStyles.spacer8} />
          <View style={pdfStyles.spacer4} />
          <Text style={labelStyle}>CONTROLS</Text>
          <View style={pdfStyles.spacer8} />
          {data.length ? <ControlsTable data={data} colors={colors} /> : <Text style={pdfStyles.value}>-</Text>}
        </View>

        <Footer footerComponent={<FooterStartComponent title="Risk management plan / Controls" />} colors={colors} />
      </Page>
    );
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps),
);
